import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CompanyProvider } from "@/context/CompanyContext";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/layout/Layout";

import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServicePage from "@/pages/ServicePage";
import ServiceLocationPage from "@/pages/ServiceLocationPage";
import ServiceAreas from "@/pages/ServiceAreas";
import FaqHub from "@/pages/FaqHub";
import ServiceAgreement from "@/pages/ServiceAgreement";
import EnrollSuccess from "@/pages/EnrollSuccess";
import ProposalView from "@/pages/ProposalView";
import LocationPage from "@/pages/LocationPage";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import Financing from "@/pages/Financing";
import MaintenancePlan from "@/pages/MaintenancePlan";
import Specials from "@/pages/Specials";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Reviews from "@/pages/Reviews";
import Careers from "@/pages/Careers";
import LifetimeWarranty from "@/pages/LifetimeWarranty";
import LifetimeWarrantySpoke from "@/pages/LifetimeWarrantySpoke";
import Guarantees from "@/pages/Guarantees";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";
import SignPage from "@/pages/SignPage";
import VeteranGiveaway from "@/pages/VeteranGiveaway";

const Site = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CompanyProvider>
          <AuthProvider>
            <Routes>
              {/* Admin (no site chrome) */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Dashboard />} />
              <Route path="/admin/:section" element={<Dashboard />} />

              {/* Public document signing page (no site chrome) */}
              <Route path="/sign/:token" element={<SignPage />} />

              {/* Marketing site */}
              <Route path="/" element={<Site><Home /></Site>} />
              <Route path="/services" element={<Site><ServicesIndex /></Site>} />
              <Route path="/service-areas" element={<Site><ServiceAreas /></Site>} />
              <Route path="/service-areas/:slug" element={<Site><LocationPage /></Site>} />
              <Route path="/blog" element={<Site><BlogIndex /></Site>} />
              <Route path="/blog/:slug" element={<Site><BlogPost /></Site>} />
              <Route path="/financing" element={<Site><Financing /></Site>} />
              <Route path="/maintenance-plan" element={<Site><MaintenancePlan /></Site>} />
              <Route path="/specials" element={<Site><Specials /></Site>} />
              <Route path="/promotions" element={<Site><Specials /></Site>} />
              <Route path="/about-us" element={<Site><About /></Site>} />
              <Route path="/contact-us" element={<Site><Contact /></Site>} />
              <Route path="/reviews" element={<Site><Reviews /></Site>} />
              <Route path="/careers" element={<Site><Careers /></Site>} />
              <Route path="/lifetime-warranty" element={<Site><LifetimeWarranty /></Site>} />
              <Route path="/lifetime-warranty/:spokeSlug" element={<Site><LifetimeWarrantySpoke /></Site>} />
              <Route path="/guarantees" element={<Site><Guarantees /></Site>} />
              <Route path="/veteran-hvac-giveaway" element={<Site><VeteranGiveaway /></Site>} />
              <Route path="/proposal/:token" element={<ProposalView />} />
              <Route path="/limited-warranty" element={<Navigate to="/lifetime-warranty" replace />} />
              <Route path="/faq" element={<Site><FaqHub /></Site>} />
              <Route path="/service-agreement" element={<Site><ServiceAgreement /></Site>} />
              <Route path="/service-agreement/success" element={<Site><EnrollSuccess /></Site>} />
              <Route path="/compare-systems" element={<Navigate to="/services" replace />} />
              <Route path="/:serviceSlug/:citySlug" element={<Site><ServiceLocationPage /></Site>} />
              <Route path="/:slug" element={<Site><ServicePage /></Site>} />
              <Route path="*" element={<Site><NotFound /></Site>} />
            </Routes>
            <Toaster position="top-center" richColors />
          </AuthProvider>
        </CompanyProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
